// extracted by mini-css-extract-plugin
export default {"Canvas":"Canvas_Canvas__fidcH","GeneratedImage":"Canvas_GeneratedImage__YhsE1"};